export default __webpack_public_path__ + "static/media/lulo-bank.2dfc0ade.svg";